import get from 'lodash.get';

const getLocaleCookie = (rootState) =>
  get(rootState, 'config.common.authtkt.current_language_cookie');

export default getLocaleCookie;
